module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar _uuid = Math.floor((Math.random() * 1000000) + 1);\nvar currentTitle = '';\nif (typeof title !== 'undefined') {\n    currentTitle = title;\n} else if (typeof alt !== 'undefined') {\n    currentTitle = alt;\n}\n\nvar isPromotionGrid = typeof carouselModel !== 'undefined' && carouselModel === \"promotion\";\n\nvar phatomTitle = currentTitle;\n\nif (typeof dataTracking !== 'undefined') {\n    var splittedTracking = dataTracking.split('|');\n    phatomTitle = splittedTracking[0];\n}\n\nvar currentId;\nif (typeof id !== 'undefined') {\n    currentId = id\n} else if (typeof contentId !== 'undefined') {\n    currentId = contentId\n}\n\nvar currentContentType = 'show';\n\nif (typeof contentType !== 'undefined') {\n    currentContentType = contentType;\n}\n\nif (typeof isMovie !== 'undefined') {\n    currentContentType = 'movie';\n}\n\nvar impressionContentType = currentContentType;\nif (typeof isOnNow !== 'undefined') {\n    impressionContentType = streamType;\n}\n\nif ((typeof locked !== 'undefined' || typeof bundleLocked !== 'undefined') && typeof isUserSubscriber !== 'undefined') {\n    lockIconClass = 'bundle-lock portrait';\n    lockGradientClass = 'bundle-lock-gradient';\n}\n\nvar currentCmsId = '';\nif (typeof cmsId !== 'undefined') {\n    currentCmsId = cmsId;\n}\n\nvar linkClasses = '';\nif (typeof status !== 'undefined' && status === 'PREMIUM' && typeof isUserSubscriber !== 'undefined' && !isUserSubscriber) {\n    linkClasses += ' subscribe';\n}\n\nvar linkClass = ''\nif (typeof promoTile !== 'undefined' && !promoTile && hasContentHighlight) {\n    linkClass = 'ch-link'\n}\n\nvar ctaText = ''\nif (typeof button !== 'undefined') {\n    ctaText = button.label ?? \"\"\n}\n%>\n<article class=\"grid-view-item\" style=\"opacity: 1;\">\n    <!-- ABTest: homepage descriptions :: contentId used by growth team -->\n    <a class=\"link <%= linkClass %> <%= (typeof status !== 'undefined' && status === 'PREMIUM' && typeof isUserSubscriber !== 'undefined' && isUserSubscriber)?'subscribe':'' %> <%= linkClasses %>\"\n        <% if (typeof ctaText !== 'undefined') { %>\n            data-cta=\"<%= ctaText %>\"\n        <% } %>\n        <% if (typeof currentId !== 'undefined') { %>\n            id=\"<%= currentId %>\"\n        <% } %>\n\n        <% if (typeof showId !== 'undefined') { %>\n            data-showId=\"<%= showId %>\"\n        <% } %>\n\n        <% if (typeof movieId !== 'undefined') { %>\n            data-movieId=\"<%= movieId %>\"\n        <% } %>\n\n        <% if (typeof genre !== 'undefined') { %>\n            data-genre=\"<%= genre %>\"\n        <% } %>\n\n        <% if (typeof showGenre !== 'undefined') { %>\n            data-genre=\"<%= showGenre %>\"\n        <% } %>\n\n        <% if (typeof href !== 'undefined' && href !== '') { %>\n            href=\"<%= href %>\"\n        <% } %>\n\n        <% if (typeof actionTarget !== 'undefined' && actionTarget !== '') { %>\n            target=\"<%= actionTarget %>\"\n        <% } %>\n\n        <% if (typeof currentTitle !== 'undefined' && currentTitle !== '') { %>\n            title=\"<%= currentTitle %>\"\n        <% } %>\n\n        <% if (typeof aaLink !== 'undefined' && aaLink !== '') { %>\n            aa-link=\"<%= aaLink %>\"\n        <% } %>\n\n        <% if (typeof dataTracking !== 'undefined') { %>\n            data-tracking=\"<%= dataTracking %>\"\n        <% } %>\n\n        <% if (typeof content_id !== 'undefined') { %>\n            vilynx-id=\"<%=content_id%>\"\n        <% } %>\n\n        <% if (typeof contentId !== 'undefined') { %>\n            <% if (contentId) { %>\n                vilynx-id=\"<%=contentId%>\"\n            <% } %>\n        <% } %>\n\n        <% if (typeof videoContentId !== 'undefined') { %>\n            data-videoContentId=\"<%=videoContentId%>\"\n        <% } %>\n\n        <% if (typeof promoTile !== 'undefined') { %>\n            data-fathom = '<%=hubId%>||0|promo_<%=contentType%>||<%=title%>||'\n            data-impression = '<%=hubId%>||0|promo_<%=contentType%>||<%=title%>|||||'\n        <% } else { %>\n            data-fathom = '<%=typeof contentIdFathom !== 'undefined' ? contentIdFathom : ''%>|getdisplayIDAbove|<%=typeof position !== 'undefined' ? position : ''%>|<%=currentContentType%>|<%=typeof recoId !== 'undefined' ? recoId : ''%>|<%=phatomTitle%>|<%=typeof rankModel !== 'undefined' ? rankModel : ''%>|<%=typeof pvrModel !== 'undefined' ? pvrModel : ''%>'\n            data-impression = '<%=typeof contentIdFathom !== 'undefined' ? contentIdFathom : ''%>|getdisplayIDAbove|<%=typeof position !== 'undefined' ? position : ''%>|<%=impressionContentType%>|<%=typeof recoId !== 'undefined' ? recoId : ''%>|<%=phatomTitle%>|<%=typeof rankModel !== 'undefined' ? rankModel : ''%>|<%=typeof pvrModel !== 'undefined' ? pvrModel : ''%>|<%=typeof badgeLabel !== 'undefined' ? badgeLabel : ''%>|<%=typeof bundleLocked !== 'undefined' ? bundleLocked : ''%>|<%=currentCmsId%>'\n        <% } %>\n    >\n\n        <div class=\"thumb-wrapper <% if (typeof onNowTitle !== 'undefined') { %>always-on<% } %>\"  style=\"background-image: linear-gradient(240deg, #<%= typeof startHexColor !== 'undefined' ? startHexColor : '' %>, #<%= typeof endHexColor !== 'undefined' ? endHexColor : '' %>)\">\n\n            <% if (badgeLabel){ %>\n              <div class=\"new-item-container\">\n                <div class=\"new-item\"><%= badgeLabel %></div>\n              </div>\n            <% } %>\n\n            <% if (isPromotionGrid) { %>\n                <img class=\"thumb lazy\"\n                    data-src=\"<%= filepathPromoTilePosterImage %>\"\n                    alt=\"<%= alt %>\"\n                    src=\"<%= filepathPromoTilePosterImage %>\"\n                />\n            <% } else { %>\n                <img class=\"thumb lazy\"\n                    <% if (typeof thumb !== 'undefined') { %>\n                        data-src=\"<%= thumb %>\"\n                    <% } %>\n                    <% if (typeof alt !== 'undefined') { %>\n                        alt=\"<%= alt %>\"\n                    <% } %>\n                >\n            <% } %>\n\n            <% if (typeof editable !== 'undefined') { %>\n                <label class=\"edit-container\">\n                    <input type=\"checkbox\"\n                        name=\"editor\"\n                        <% if (showId) { %>\n                            value=\"<%= showId %>/<%=showSeriesId%>|<%=showSeriesTitle%>|<%=showGenre%>|<%=showDayPart%>|<%=showEpisodeId%>|<%=showEpisodeLabel%>|<%=showSeasonNumber%>|<%=showEpisodeNumber%>|<%=showAirDate%>|<%=contentId%>\"\n                        <% } %>\n                    >\n                    <span class=\"checkmark\"  ></span>\n                    <div class=\"overlay\" ></div>\n                </label>\n            <% } %>\n\n            <% if (typeof background !== 'undefined') { %>\n                <img class=\"brand-bkgd-static\" src=\"<%= background %>\" onerror='this.src=\"<%= fallbackBackground %>\"'>\n            <% } %>\n\n            <% if (typeof brandLogo !== 'undefined' && !isPromotionGrid) { %>\n                <div class=\"brandLogo <%= slug %>\">\n                    <img data-src=\"<%= brandLogo %>\" src=\"<%= brandLogo %>\" alt=\"<%= currentTitle %>\">\n                </div>\n            <% } %>\n\n            <% if (typeof isUserSubscriber !== 'undefined' && isUserSubscriber && typeof bundleLocked !== 'undefined' && bundleLocked) { %>\n                <div class=\"<%= lockGradientClass %>\"></div>\n            <% } %>\n\n            <% if (typeof isContentAccessibleInCMS !== 'undefined' && !isContentAccessibleInCMS) { %>\n                <% if (typeof onNowTitle === 'undefined' || !onNowTitle) { %>\n                    <div class=\"label <%= lockIconClass %>\"><img src=\"<%= lockIcon %>\"/></div>\n                <% } %>\n            <% } else if (typeof icon !== 'undefined') { %>\n                <div class=\"label <%= icon %> circle-sm\"></div>\n            <% } else if (typeof status !== 'undefined' && status === 'PREMIUM' && typeof isUserSubscriber !== 'undefined' && !isUserSubscriber) { %>\n                <div class=\"subscribe-gradient\"></div>\n                <% if (typeof kidsContentLabel === \"undefined\" || kidsContentLabel === null) { %>\n                    <div class=\"label subscribe\"><%= getLocale('subscribe') %></div>\n                <% } else { %>\n                    <div class=\"label subscribe\"><%= kidsContentLabel %></div>\n                <% } %>\n            <% } else if (status === 'AVAILABLE') { %>\n                <div class=\"play label circle-sm\">\n                    <% if (content_id) { %>\n                        <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                            xmlns=\"http://www.w3.org/2000/svg\">\n                            <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                                cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                        </svg>\n                    <% } %>\n                </div>\n            <% } %>\n        </div>\n    </a>\n</article>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/carousels/__gridPortraitView.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
var _uuid = Math.floor((Math.random() * 1000000) + 1);
var currentTitle = '';
if (typeof title !== 'undefined') {
    currentTitle = title;
} else if (typeof alt !== 'undefined') {
    currentTitle = alt;
}

var isPromotionGrid = typeof carouselModel !== 'undefined' && carouselModel === "promotion";

var phatomTitle = currentTitle;

if (typeof dataTracking !== 'undefined') {
    var splittedTracking = dataTracking.split('|');
    phatomTitle = splittedTracking[0];
}

var currentId;
if (typeof id !== 'undefined') {
    currentId = id
} else if (typeof contentId !== 'undefined') {
    currentId = contentId
}

var currentContentType = 'show';

if (typeof contentType !== 'undefined') {
    currentContentType = contentType;
}

if (typeof isMovie !== 'undefined') {
    currentContentType = 'movie';
}

var impressionContentType = currentContentType;
if (typeof isOnNow !== 'undefined') {
    impressionContentType = streamType;
}

if ((typeof locked !== 'undefined' || typeof bundleLocked !== 'undefined') && typeof isUserSubscriber !== 'undefined') {
    lockIconClass = 'bundle-lock portrait';
    lockGradientClass = 'bundle-lock-gradient';
}

var currentCmsId = '';
if (typeof cmsId !== 'undefined') {
    currentCmsId = cmsId;
}

var linkClasses = '';
if (typeof status !== 'undefined' && status === 'PREMIUM' && typeof isUserSubscriber !== 'undefined' && !isUserSubscriber) {
    linkClasses += ' subscribe';
}

var linkClass = ''
if (typeof promoTile !== 'undefined' && !promoTile && hasContentHighlight) {
    linkClass = 'ch-link'
}

var ctaText = ''
if (typeof button !== 'undefined') {
    ctaText = button.label ?? ""
}

    ; __line = 65
    ; __append("\n<article class=\"grid-view-item\" style=\"opacity: 1;\">\n    <!-- ABTest: homepage descriptions :: contentId used by growth team -->\n    <a class=\"link ")
    ; __line = 68
    ; __append(escapeFn( linkClass ))
    ; __append(" ")
    ; __append(escapeFn( (typeof status !== 'undefined' && status === 'PREMIUM' && typeof isUserSubscriber !== 'undefined' && isUserSubscriber)?'subscribe':'' ))
    ; __append(" ")
    ; __append(escapeFn( linkClasses ))
    ; __append("\"\n        ")
    ; __line = 69
    ;  if (typeof ctaText !== 'undefined') { 
    ; __append("\n            data-cta=\"")
    ; __line = 70
    ; __append(escapeFn( ctaText ))
    ; __append("\"\n        ")
    ; __line = 71
    ;  } 
    ; __append("\n        ")
    ; __line = 72
    ;  if (typeof currentId !== 'undefined') { 
    ; __append("\n            id=\"")
    ; __line = 73
    ; __append(escapeFn( currentId ))
    ; __append("\"\n        ")
    ; __line = 74
    ;  } 
    ; __append("\n\n        ")
    ; __line = 76
    ;  if (typeof showId !== 'undefined') { 
    ; __append("\n            data-showId=\"")
    ; __line = 77
    ; __append(escapeFn( showId ))
    ; __append("\"\n        ")
    ; __line = 78
    ;  } 
    ; __append("\n\n        ")
    ; __line = 80
    ;  if (typeof movieId !== 'undefined') { 
    ; __append("\n            data-movieId=\"")
    ; __line = 81
    ; __append(escapeFn( movieId ))
    ; __append("\"\n        ")
    ; __line = 82
    ;  } 
    ; __append("\n\n        ")
    ; __line = 84
    ;  if (typeof genre !== 'undefined') { 
    ; __append("\n            data-genre=\"")
    ; __line = 85
    ; __append(escapeFn( genre ))
    ; __append("\"\n        ")
    ; __line = 86
    ;  } 
    ; __append("\n\n        ")
    ; __line = 88
    ;  if (typeof showGenre !== 'undefined') { 
    ; __append("\n            data-genre=\"")
    ; __line = 89
    ; __append(escapeFn( showGenre ))
    ; __append("\"\n        ")
    ; __line = 90
    ;  } 
    ; __append("\n\n        ")
    ; __line = 92
    ;  if (typeof href !== 'undefined' && href !== '') { 
    ; __append("\n            href=\"")
    ; __line = 93
    ; __append(escapeFn( href ))
    ; __append("\"\n        ")
    ; __line = 94
    ;  } 
    ; __append("\n\n        ")
    ; __line = 96
    ;  if (typeof actionTarget !== 'undefined' && actionTarget !== '') { 
    ; __append("\n            target=\"")
    ; __line = 97
    ; __append(escapeFn( actionTarget ))
    ; __append("\"\n        ")
    ; __line = 98
    ;  } 
    ; __append("\n\n        ")
    ; __line = 100
    ;  if (typeof currentTitle !== 'undefined' && currentTitle !== '') { 
    ; __append("\n            title=\"")
    ; __line = 101
    ; __append(escapeFn( currentTitle ))
    ; __append("\"\n        ")
    ; __line = 102
    ;  } 
    ; __append("\n\n        ")
    ; __line = 104
    ;  if (typeof aaLink !== 'undefined' && aaLink !== '') { 
    ; __append("\n            aa-link=\"")
    ; __line = 105
    ; __append(escapeFn( aaLink ))
    ; __append("\"\n        ")
    ; __line = 106
    ;  } 
    ; __append("\n\n        ")
    ; __line = 108
    ;  if (typeof dataTracking !== 'undefined') { 
    ; __append("\n            data-tracking=\"")
    ; __line = 109
    ; __append(escapeFn( dataTracking ))
    ; __append("\"\n        ")
    ; __line = 110
    ;  } 
    ; __append("\n\n        ")
    ; __line = 112
    ;  if (typeof content_id !== 'undefined') { 
    ; __append("\n            vilynx-id=\"")
    ; __line = 113
    ; __append(escapeFn(content_id))
    ; __append("\"\n        ")
    ; __line = 114
    ;  } 
    ; __append("\n\n        ")
    ; __line = 116
    ;  if (typeof contentId !== 'undefined') { 
    ; __append("\n            ")
    ; __line = 117
    ;  if (contentId) { 
    ; __append("\n                vilynx-id=\"")
    ; __line = 118
    ; __append(escapeFn(contentId))
    ; __append("\"\n            ")
    ; __line = 119
    ;  } 
    ; __append("\n        ")
    ; __line = 120
    ;  } 
    ; __append("\n\n        ")
    ; __line = 122
    ;  if (typeof videoContentId !== 'undefined') { 
    ; __append("\n            data-videoContentId=\"")
    ; __line = 123
    ; __append(escapeFn(videoContentId))
    ; __append("\"\n        ")
    ; __line = 124
    ;  } 
    ; __append("\n\n        ")
    ; __line = 126
    ;  if (typeof promoTile !== 'undefined') { 
    ; __append("\n            data-fathom = '")
    ; __line = 127
    ; __append(escapeFn(hubId))
    ; __append("||0|promo_")
    ; __append(escapeFn(contentType))
    ; __append("||")
    ; __append(escapeFn(title))
    ; __append("||'\n            data-impression = '")
    ; __line = 128
    ; __append(escapeFn(hubId))
    ; __append("||0|promo_")
    ; __append(escapeFn(contentType))
    ; __append("||")
    ; __append(escapeFn(title))
    ; __append("|||||'\n        ")
    ; __line = 129
    ;  } else { 
    ; __append("\n            data-fathom = '")
    ; __line = 130
    ; __append(escapeFn(typeof contentIdFathom !== 'undefined' ? contentIdFathom : ''))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(typeof position !== 'undefined' ? position : ''))
    ; __append("|")
    ; __append(escapeFn(currentContentType))
    ; __append("|")
    ; __append(escapeFn(typeof recoId !== 'undefined' ? recoId : ''))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(typeof rankModel !== 'undefined' ? rankModel : ''))
    ; __append("|")
    ; __append(escapeFn(typeof pvrModel !== 'undefined' ? pvrModel : ''))
    ; __append("'\n            data-impression = '")
    ; __line = 131
    ; __append(escapeFn(typeof contentIdFathom !== 'undefined' ? contentIdFathom : ''))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(typeof position !== 'undefined' ? position : ''))
    ; __append("|")
    ; __append(escapeFn(impressionContentType))
    ; __append("|")
    ; __append(escapeFn(typeof recoId !== 'undefined' ? recoId : ''))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(typeof rankModel !== 'undefined' ? rankModel : ''))
    ; __append("|")
    ; __append(escapeFn(typeof pvrModel !== 'undefined' ? pvrModel : ''))
    ; __append("|")
    ; __append(escapeFn(typeof badgeLabel !== 'undefined' ? badgeLabel : ''))
    ; __append("|")
    ; __append(escapeFn(typeof bundleLocked !== 'undefined' ? bundleLocked : ''))
    ; __append("|")
    ; __append(escapeFn(currentCmsId))
    ; __append("'\n        ")
    ; __line = 132
    ;  } 
    ; __append("\n    >\n\n        <div class=\"thumb-wrapper ")
    ; __line = 135
    ;  if (typeof onNowTitle !== 'undefined') { 
    ; __append("always-on")
    ;  } 
    ; __append("\"  style=\"background-image: linear-gradient(240deg, #")
    ; __append(escapeFn( typeof startHexColor !== 'undefined' ? startHexColor : '' ))
    ; __append(", #")
    ; __append(escapeFn( typeof endHexColor !== 'undefined' ? endHexColor : '' ))
    ; __append(")\">\n\n            ")
    ; __line = 137
    ;  if (badgeLabel){ 
    ; __append("\n              <div class=\"new-item-container\">\n                <div class=\"new-item\">")
    ; __line = 139
    ; __append(escapeFn( badgeLabel ))
    ; __append("</div>\n              </div>\n            ")
    ; __line = 141
    ;  } 
    ; __append("\n\n            ")
    ; __line = 143
    ;  if (isPromotionGrid) { 
    ; __append("\n                <img class=\"thumb lazy\"\n                    data-src=\"")
    ; __line = 145
    ; __append(escapeFn( filepathPromoTilePosterImage ))
    ; __append("\"\n                    alt=\"")
    ; __line = 146
    ; __append(escapeFn( alt ))
    ; __append("\"\n                    src=\"")
    ; __line = 147
    ; __append(escapeFn( filepathPromoTilePosterImage ))
    ; __append("\"\n                />\n            ")
    ; __line = 149
    ;  } else { 
    ; __append("\n                <img class=\"thumb lazy\"\n                    ")
    ; __line = 151
    ;  if (typeof thumb !== 'undefined') { 
    ; __append("\n                        data-src=\"")
    ; __line = 152
    ; __append(escapeFn( thumb ))
    ; __append("\"\n                    ")
    ; __line = 153
    ;  } 
    ; __append("\n                    ")
    ; __line = 154
    ;  if (typeof alt !== 'undefined') { 
    ; __append("\n                        alt=\"")
    ; __line = 155
    ; __append(escapeFn( alt ))
    ; __append("\"\n                    ")
    ; __line = 156
    ;  } 
    ; __append("\n                >\n            ")
    ; __line = 158
    ;  } 
    ; __append("\n\n            ")
    ; __line = 160
    ;  if (typeof editable !== 'undefined') { 
    ; __append("\n                <label class=\"edit-container\">\n                    <input type=\"checkbox\"\n                        name=\"editor\"\n                        ")
    ; __line = 164
    ;  if (showId) { 
    ; __append("\n                            value=\"")
    ; __line = 165
    ; __append(escapeFn( showId ))
    ; __append("/")
    ; __append(escapeFn(showSeriesId))
    ; __append("|")
    ; __append(escapeFn(showSeriesTitle))
    ; __append("|")
    ; __append(escapeFn(showGenre))
    ; __append("|")
    ; __append(escapeFn(showDayPart))
    ; __append("|")
    ; __append(escapeFn(showEpisodeId))
    ; __append("|")
    ; __append(escapeFn(showEpisodeLabel))
    ; __append("|")
    ; __append(escapeFn(showSeasonNumber))
    ; __append("|")
    ; __append(escapeFn(showEpisodeNumber))
    ; __append("|")
    ; __append(escapeFn(showAirDate))
    ; __append("|")
    ; __append(escapeFn(contentId))
    ; __append("\"\n                        ")
    ; __line = 166
    ;  } 
    ; __append("\n                    >\n                    <span class=\"checkmark\"  ></span>\n                    <div class=\"overlay\" ></div>\n                </label>\n            ")
    ; __line = 171
    ;  } 
    ; __append("\n\n            ")
    ; __line = 173
    ;  if (typeof background !== 'undefined') { 
    ; __append("\n                <img class=\"brand-bkgd-static\" src=\"")
    ; __line = 174
    ; __append(escapeFn( background ))
    ; __append("\" onerror='this.src=\"")
    ; __append(escapeFn( fallbackBackground ))
    ; __append("\"'>\n            ")
    ; __line = 175
    ;  } 
    ; __append("\n\n            ")
    ; __line = 177
    ;  if (typeof brandLogo !== 'undefined' && !isPromotionGrid) { 
    ; __append("\n                <div class=\"brandLogo ")
    ; __line = 178
    ; __append(escapeFn( slug ))
    ; __append("\">\n                    <img data-src=\"")
    ; __line = 179
    ; __append(escapeFn( brandLogo ))
    ; __append("\" src=\"")
    ; __append(escapeFn( brandLogo ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( currentTitle ))
    ; __append("\">\n                </div>\n            ")
    ; __line = 181
    ;  } 
    ; __append("\n\n            ")
    ; __line = 183
    ;  if (typeof isUserSubscriber !== 'undefined' && isUserSubscriber && typeof bundleLocked !== 'undefined' && bundleLocked) { 
    ; __append("\n                <div class=\"")
    ; __line = 184
    ; __append(escapeFn( lockGradientClass ))
    ; __append("\"></div>\n            ")
    ; __line = 185
    ;  } 
    ; __append("\n\n            ")
    ; __line = 187
    ;  if (typeof isContentAccessibleInCMS !== 'undefined' && !isContentAccessibleInCMS) { 
    ; __append("\n                ")
    ; __line = 188
    ;  if (typeof onNowTitle === 'undefined' || !onNowTitle) { 
    ; __append("\n                    <div class=\"label ")
    ; __line = 189
    ; __append(escapeFn( lockIconClass ))
    ; __append("\"><img src=\"")
    ; __append(escapeFn( lockIcon ))
    ; __append("\"/></div>\n                ")
    ; __line = 190
    ;  } 
    ; __append("\n            ")
    ; __line = 191
    ;  } else if (typeof icon !== 'undefined') { 
    ; __append("\n                <div class=\"label ")
    ; __line = 192
    ; __append(escapeFn( icon ))
    ; __append(" circle-sm\"></div>\n            ")
    ; __line = 193
    ;  } else if (typeof status !== 'undefined' && status === 'PREMIUM' && typeof isUserSubscriber !== 'undefined' && !isUserSubscriber) { 
    ; __append("\n                <div class=\"subscribe-gradient\"></div>\n                ")
    ; __line = 195
    ;  if (typeof kidsContentLabel === "undefined" || kidsContentLabel === null) { 
    ; __append("\n                    <div class=\"label subscribe\">")
    ; __line = 196
    ; __append(escapeFn( getLocale('subscribe') ))
    ; __append("</div>\n                ")
    ; __line = 197
    ;  } else { 
    ; __append("\n                    <div class=\"label subscribe\">")
    ; __line = 198
    ; __append(escapeFn( kidsContentLabel ))
    ; __append("</div>\n                ")
    ; __line = 199
    ;  } 
    ; __append("\n            ")
    ; __line = 200
    ;  } else if (status === 'AVAILABLE') { 
    ; __append("\n                <div class=\"play label circle-sm\">\n                    ")
    ; __line = 202
    ;  if (content_id) { 
    ; __append("\n                        <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                            xmlns=\"http://www.w3.org/2000/svg\">\n                            <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                                cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                        </svg>\n                    ")
    ; __line = 208
    ;  } 
    ; __append("\n                </div>\n            ")
    ; __line = 210
    ;  } 
    ; __append("\n        </div>\n    </a>\n</article>\n")
    ; __line = 214
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/carousels/__gridPortraitView.tpl"

}